@if (user$ | async; as user) {
  <nz-layout class="app-layout">
    <nz-drawer (nzOnClose)="showUserPanel = false" [nzClosable]="false" [nzVisible]="showUserPanel"
               [nzWidth]="300" nzPlacement="right" nzTitle="User Profile">
      <ng-container *nzDrawerContent>
        <nz-descriptions nzSize="small">
          <nz-descriptions-item nzSpan="3" nzTitle="UID">{{ user.uid }}</nz-descriptions-item>
          <nz-descriptions-item nzSpan="3" nzTitle="User Name">{{ user.name }}</nz-descriptions-item>
          <nz-descriptions-item nzSpan="3" nzTitle="Email">{{ user.email }}</nz-descriptions-item>
          <nz-descriptions-item nzSpan="3" nzTitle="Role">{{ user.role | uppercase }}</nz-descriptions-item>
          <nz-descriptions-item nzSpan="3" nzTitle="Halls">{{ user.halls }}</nz-descriptions-item>
          <nz-descriptions-item nzSpan="3" nzTitle="Session">{{ user.exp | date:'short' }}</nz-descriptions-item>
        </nz-descriptions>
      </ng-container>
    </nz-drawer>
    <nz-sider [(nzCollapsed)]="isCollapsed"
              class="menu-sidebar"
              nzBreakpoint="md"
              nzCollapsible
              nzWidth="256px">
      <div class="sidebar-logo">
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div>
            <img alt="logo" src="assets/brand-logo.jpg">
            <h1>SRiMS</h1>
          </div>
          @if (user.role !== 'res_master' && user.role !== 'res_tutor') {
            <div style="padding-right: 15px;">
              <button [queryParams]="{ module: 'welcome' }" [routerLink]="['forward']"
                      nz-button>
                <nz-icon nzTheme="outline" nzType="swap" style="font-size: 18px;"/>
              </button>
            </div>
          }
        </div>
      </div>
      <ul [nzInlineCollapsed]="isCollapsed" nz-menu nzMode="inline" nzTheme="dark">
        <li nz-submenu nzIcon="dashboard" nzTitle="Dashboard">
          <ul>
            <li nz-menu-item nzMatchRouter>
              <a routerLink="/welcome">Welcome</a>
            </li>
          </ul>
        </li>
        @for (m of menus; track m) {
          @if (m.subMenus && m.subMenus.length > 0) {
            <li [nzIcon]="m.icon" [nzTitle]="m.text" nz-submenu>
              <ul>
                @for (s of m.subMenus; track s) {
                  <li nz-menu-item nzMatchRouter>
                    <a [queryParams]="getQueryParams(m, s)" [routerLink]="getUrlSegments(m, s)">{{ s.text }}</a>
                  </li>
                }
              </ul>
            </li>
          }
        }
      </ul>
    </nz-sider>
    <nz-layout>
      <nz-header>
        <div class="app-header">
          <div class="header-title">
            {{ title }}
          </div>
          <div class="header-user">
            <nz-avatar (click)="showUserPanel = true" nzIcon="user"></nz-avatar>
            <span class="user-name">{{ user.name }}</span>
            <button (click)="logout()" nz-button nzShape="round" nzType="primary">Sign Out</button>
          </div>
        </div>
      </nz-header>
      <nz-content>
        <router-outlet></router-outlet>
      </nz-content>
    </nz-layout>
  </nz-layout>
}

